import 'css-chunksrc/client/scenes/projectListingConfiguration/styles.scss';export default {
  "projectListingConfiguration": "_projectListingConfiguration_872fh_1",
  "main": "_main_872fh_8",
  "tabs": "_tabs_872fh_14",
  "tab": "_tab_872fh_14",
  "selectedTab": "_selectedTab_872fh_34",
  "label": "_label_872fh_41",
  "footer": "_footer_872fh_48",
  "button": "_button_872fh_63"
};